/**
 * Make all keys in `T` optional. For the specified keys `K`, make their values partial.
 */
export type NestedPartial<T, K extends keyof T> = {
  [P in keyof T]?: P extends K ? Partial<T[P]> : T[P];
};
